export enum TaskStatus {
  TODO = 'ToDo',
  IN_PROGRESS = 'InProgress',
  COMPLETED = 'Completed',
  OVERDUE = 'Overdue',
}

export enum TaskTypeByAssignment {
  ME = 'me',
  OTHERS = 'others',
  ALL = 'all',
}
export enum FulfillmentType {
  DEFAULT = 'Default',
  NUMBER = 'Number',
  PHOTO = 'Photo',
  TEMPERATURE_C = 'Temperature_C',
  TEMPERATURE_F = 'Temperature_F',
}

export enum TaskAction {
  CREATED = 'Created',
  ASSIGNED = 'Assigned',
  COMPLETED = 'Completed',
  REASSIGNED = 'Reassigned',
  UPDATED = 'Updated',
  DELETED = 'Deleted',
  ACCEPTED = 'Accepted',
}

interface UserDetails {
  id: number;
  firstName: string;
  lastName: string;
  imgUrl: string;
}
export interface ITask {
  id: number;
  name: string;
  description?: string;
  image?: string;
  fulfillmentPhoto?: string;
  fulfillmentType: FulfillmentType;
  numericValue?: string;
  status: TaskStatus;
  dueDate?: Date;
  createdAt: Date;
  updatedAt: Date;
  createdBy: UserDetails;
  assignedTo: UserDetails;
  taskActvities: ITaskActivity[];
}

export interface ITaskActivity {
  id: number;
  taskId: number;
  action: TaskAction;
  timestamp: Date;
  details?: string;
  assignedTo: UserDetails;
  assignedBy: UserDetails;
}

export interface ICreateTaskRequest {
  name: string;
  description?: string;
  fulfillmentType: FulfillmentType;
  imageUrl?: string;
  dueDate?: Date;
  assignedTo: number;
}

export interface IUpdateTaskRequest {
  name?: string;
  description?: string;
  fulfillmentType?: FulfillmentType;
  numericValue?: string;
  imageUrl?: string;
  fulfillmentPhoto?: string;
  dueDate?: Date;
  assignedTo: number;
}

export interface ICompleteTaskWithPhotoRequest {
  photo: string;
}

export interface ICompleteTaskWithNumericRequest {
  numericValue: string;
}

export interface ICompleteTaskWithTemperatureRequest {
  temperature: number;
}

export interface ITaskQuery {
  status: TaskStatus;
  page: number;
  limit: number;
  assignedTo: TaskTypeByAssignment;
}

export interface ITaskIdParam {
  id: number;
}

export interface ITaskResponse {
  success: boolean;
  message: string;
  data: ITask;
}

export interface IPaginatedTaskResponse {
  success: boolean;
  message: string;
  data: {
    tasks: ITask[];
    total: number;
    page: number;
    limit: number;
  };
}

export interface ITaskHistoryResponse {
  success: boolean;
  message: string;
  data: ITaskActivity[];
}
